/**
 * Removes selected keys from given props.
 * @example
 * import React, {Component} from 'react
 * import {withRouter} from 'react-router'

 * import filterProps from './utils/filterProps'
 *
 * type Props = {
 *     +height: number,
 *     // props inherited via decorators
 *     +history: Object,
 *     +location: Object,
 *     +match: Object,
 * }
 *
 * class ExampleComponent extends Component<Props> {
 *     render() {
 *         const {height, ...rest} = (filterProps(this.props, ['history', 'location', 'match']): Props);
 *
 *         ...
 *     }
 * }
 *
 * export default withRouter(ExampleComponent)
 */
export default (props, propsToRemove = []) => {
    const newProps = { ...props };
    propsToRemove.forEach((prop) => delete newProps[prop]);
    return newProps;
};
